import { useSortable } from "@dnd-kit/sortable";
import PropTypes from "prop-types";

import DeckOfCards from "@/components/DeckOfCards";
import Item from "./Item";
import { transformCss } from "./SortableItem.style";

const propTypes = {
  /**
   * Pass this prop an object that gets passed down to the DeckOfCards component.
   * See the DeckOfCards component to learn more about these props.
   */
  deckOfCardsProps: PropTypes.object,
  /**
   * String representing a unique ID
   */
  id: PropTypes.string,
};

const SortableItem = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: props?.id });

  return (
    <Item
      css={[transition, transform ? transformCss(transform) : {}]}
      ref={setNodeRef}
    >
      <DeckOfCards
        {...props?.deckOfCardsProps}
        isSortableItem
        footer={props?.deckOfCardsProps?.footer({ attributes, listeners })}
      />
    </Item>
  );
};

SortableItem.propTypes = propTypes;
export default SortableItem;
